import axios from "axios";

import { APIEndpoints } from "@/apis/endpoints";
import { downloadAsCSV } from "@/utils/downloadFile";

export const downloadEmailMessages = async (
  getToken: CallableFunction,
  dateFrom: Date,
  dateTo: Date,
  department?: string,
) => {
  let url = APIEndpoints.SIMULATION + "/emailmessages/export/csv";
  let params = new URLSearchParams();

  const accessToken = await getToken();
  params.append("date_from", dateFrom.toISOString());
  params.append("date_to", dateTo.toISOString());
  if (department) {
    params.append("department", department);
  }

  url = url + "?" + params.toString();
  axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: "blob",
    })
    .then((response) => downloadAsCSV(response.data, "sent-emails.csv"));
};
